import React from 'react'
import { Drawer, SwipeableDrawer } from '@material-ui/core'
import cn from 'classnames'
import * as styles from './slide.module.css' 


const SlideMenu = ({ children, className = '', classes = {}, open = false, onToggle}) => {
  const toggleDrawer = (isOpen) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    onToggle(isOpen)
  }

  return (
    <>
      <Drawer 
        className={cn(className, styles.desktopMenu)}
        variant="permanent"
        classes={classes}
        anchor="left"
      >
        {children}
      </Drawer>
      <SwipeableDrawer
        className={cn(className, styles.phoneMenu)}
        classes={classes}
        anchor="left"
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        open={open}
        onClick={toggleDrawer(false)}
      >
        {children}
      </SwipeableDrawer>
    </>
  )
}

export default SlideMenu